// extracted by mini-css-extract-plugin
module.exports = {"container":"External_container__zkiQa"};